import { Inline, Typography, styled } from '@bayon/commons';

export const Container = styled(Inline)({});

export const Search = styled(Typography)({
  padding: '0px 4px',
});
